import React from 'react';
import { photos } from '../../data/site';
import { ButtonLink } from '../ui/ButtonLink';
export function StoryTeaser() {
  return <section aria-labelledby="story-title" className="w-full border-y border-line bg-stage" data-id="element-145" data-mp="iu040f2bb84u">
      <div className="mx-auto grid max-w-7xl grid-cols-1 gap-12 px-5 py-24 md:px-10 lg:grid-cols-12 lg:items-center lg:py-32" data-id="element-146" data-mp="nnm6jeerhvmx">
        <figure className="lg:col-span-5" data-id="element-147" data-mp="sngw9emswf6e">
          <img src={photos.guitarGarden} alt="Bas met zijn akoestische gitaar voor een groene haag" style={{
          objectPosition: '55% 40%'
        }} className="aspect-[4/5] w-full rounded-sm object-cover" data-id="element-148" data-mp="3r3tazn503wwr" />
        </figure>
        <div className="lg:col-span-6 lg:col-start-7" data-id="element-149" data-mp="8xey7rigxszy">
          <h2 id="story-title" className="sr-only" data-id="element-150" data-mp="8y6m0g5tqmfo">
            Over Bas
          </h2>
          <blockquote data-id="element-151" data-mp="1g9x92ulxi6md">
            <p className="font-serif text-4xl leading-[1.12] text-paper md:text-5xl" data-id="element-152" data-mp="1gap3w37pc0bl">
              “Die gitaristen op het podium hadden iets <em className="text-amber" data-id="element-153" data-mp="2a7qe9kbm23en">magisch</em> voor mij als kind. Dat wilde ik
              ook.”
            </p>
            <footer className="mt-6 text-sm text-muted" data-id="element-154" data-mp="2585gvec3a341">— Bas, in Hei &amp; Wei (2025)</footer>
          </blockquote>
          <p className="mt-10 max-w-lg text-[17px] leading-relaxed text-sand" data-id="element-155" data-mp="208j230gm4et4">
            Op mijn zevende kreeg ik na lang smeken mijn eerste gitaar. Na een studie bedrijfskunde koos ik alsnog voor mijn
            droom en rondde in 2023 het Conservatorium van Amsterdam af. Vandaag geef ik les, dirigeer ik, speel ik in een
            coverband en schrijf ik mijn eigen nummers.
          </p>
          <ButtonLink to="/over-mij" variant="outline" arrow className="mt-8" data-id="element-156" data-mp="1hib1ap0dy0g3">
            Lees mijn verhaal
          </ButtonLink>
        </div>
      </div>
    </section>;
}